import Timeline from './Timeline';
import ProcessTimeline from './ProcessTimeline';

export { Timeline, ProcessTimeline };
export default { Timeline, ProcessTimeline };
